module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5aeEC"))).then(() => parcelRequire('ikE14'));